import { Banner } from '@/modules/shop/models/offerModels';

export const filterByFeedId = (cards: Banner[], feedId: string) => {
  const filteredContentCards: Banner[] = cards.filter((banner) =>
    (banner.brazeContentCardInstance?.extras.feed_id ?? '')
      .split(',')
      .includes(feedId)
  );

  return filteredContentCards;
};
